import { cva } from "class-variance-authority";

export const sliderContentVariants = cva(
  "flex snap-x snap-mandatory overflow-x-auto overflow-y-hidden scroll-smooth [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
  {
    variants: {
      bleed: {
        none: "",
        gutter: "-mx-5 px-5",
      },
    },
    defaultVariants: { bleed: "none" },
  },
);

export const sliderItemVariants = cva("min-w-0 shrink-0", {
  variants: {
    align: {
      start: "snap-start",
      center: "flex snap-center items-center justify-center",
    },
  },
  defaultVariants: { align: "start" },
});

export const sliderArrowVariants = cva(
  "absolute touch-manipulation rounded-full shadow-sm",
  {
    variants: {
      placement: {
        outside: "inset-y-0 my-auto",
        edge: "disabled:hidden z-20 inset-y-auto top-1/2 my-0 size-8 -translate-y-1/2 rounded-md bg-background max-sm:hidden dark:bg-background",
      },
    },
    defaultVariants: { placement: "outside" },
  },
);

export const sliderArrowIconVariants = cva("", {
  variants: {
    placement: {
      outside: "",
      edge: "size-6",
    },
  },
  defaultVariants: { placement: "outside" },
});

const HORIZONTALLY_CENTRED = "left-1/2 -translate-x-1/2";

export const sliderIndicatorsVariants = cva(
  `${HORIZONTALLY_CENTRED} flex rtl:flex-row-reverse`,
  {
    variants: {
      placement: {
        overlay: "absolute bottom-8",
        below: "relative bottom-0 mt-4 justify-center",
      },
    },
    defaultVariants: { placement: "overlay" },
  },
);

export const arrowOffset = (
  placement: "outside" | "edge",
  side: "previous" | "next",
  dir: "ltr" | "rtl",
) => {
  if (placement === "outside") {
    return side === "previous" ? "-left-12" : "-right-12";
  }
  const sitsAtStart = side === "previous" ? dir !== "rtl" : dir === "rtl";
  return sitsAtStart ? "-left-4 right-auto" : "-right-4 left-auto";
};
